import React, { useEffect, useContext } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ApiService from '../../../services/ApiService'
import { AuthContext } from '../../../contexts/AuthContext'
import { validateToken } from '../../../utils/tokenValidation'

const MagicLogin = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const hash = searchParams.get('h')
  const { setToken } = useContext(AuthContext)

  useEffect(() => {
    const performMagicLogin = async () => {
      try {
        if (!hash) throw new Error('Hash ausente')

        const response = await ApiService.auth.magicLogin(hash)
        const { access_token, user } = response.data

        localStorage.setItem('token', access_token)
        setToken(access_token)
        const validation = validateToken(access_token)
        const decodedToken = validation.decodedToken as { role?: string; tenantId?: number } | undefined
        const isTenantClient = decodedToken?.role === 'TENANT_CLIENT'
        const isAcoTenant = decodedToken?.tenantId !== 2
        const redirectPath = isTenantClient && isAcoTenant ? '/panel/steel/tracking' : '/panel'
        setTimeout(() => {
          window.location.href = redirectPath
        }, 100)
      } catch (err: any) {
        console.error('❌ Erro no Magic Login:', err)
        navigate('/login')
      }
    }

    performMagicLogin()
  }, [hash, navigate, setToken])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <p>Autenticando seu acesso...</p>
    </div>
  )
}

export default MagicLogin
